import { responseApi } from "use-hook-api"


const APIURL = process.env.NEXT_PUBLIC_REVIEWS_API_URL
const ID = process.env.NEXT_PUBLIC_REVIEWS_UID

export const ReviewsApi = () => {
    return responseApi(`${APIURL}reviews/customer/${ID}`, 'get')
}
